let isDebug = false

export default {
  url:'http://101.201.112.111:9060',
  ip360Url: 'http://123.57.229.116:8080',
  // url:'http://59.110.44.147:9061/',
  // vcodeUrl: 'http://59.110.44.147:9061/webapi/user/login/getCode' //新测试服务器
  vcodeUrl: 'http://101.201.112.111:9060/webapi/user/login/getCode' //116连接测试服务器
  // vcodeUrl: 'http://101.201.112.111:9060/webapi/user/login/getCode'
  // vcodeUrl: 'http://59.110.44.147:9060/webapi/user/login/getCode'  //

}



// WEBPACK FOOTER //
// ./src/lib/globalConfig.js